var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversationColorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C12.5 5.37062 12.5 4.55593 12.2662 3.90244C11.8627 2.77481 10.9752 1.8873 9.84756 1.48382C9.19407 1.25 8.37938 1.25 6.75 1.25V1.25C5.12062 1.25 4.30593 1.25 3.65244 1.48382C2.52481 1.8873 1.6373 2.77481 1.23382 3.90244C1 4.55593 1 5.37062 1 7V10.75C1 11.6928 1 12.1642 1.29289 12.4571C1.58579 12.75 2.05719 12.75 3 12.75H6.75C8.37938 12.75 9.19407 12.75 9.84756 12.5162C10.9752 12.1127 11.8627 11.2252 12.2662 10.0976C12.5 9.44407 12.5 8.62938 12.5 7V7Z",
    stroke: "#E2669A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 5.5625L8.90625 5.5625",
    stroke: "#E2669A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 8.4375H6.75",
    stroke: "#E2669A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationColorIcon);
export default __webpack_public_path__ + "static/media/ConversationColorIcon.35b6bb37a23bf8002f434507b7c3b9b7.svg";
export { ForwardRef as ReactComponent };